/**
 * Module dependencies.
 */

import styled from '@emotion/styled';

/**
 * Export `ImageWrapper` styled component.
 */

export const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 40px;
`;

/**
 * Export `ImageCatalog` styled component.
 */

export const ImageCatalog = styled.img`
  margin: 0 auto;
  width: 320px;

  @media (max-width: 576px) {
    width: 200px;
  }
`;
